module.exports = __webpack_public_path__ + "img/home3.cf4a1a64.jpg";